import { PropsWithChildren, ReactNode, RefObject, useEffect, useRef } from 'react'

import { ColumnPinning } from '../../DataGrid.types'
import { getLeftRightVars, gridClassNames, StickyController } from '../../utils'
import * as S from './HeaderGroupCell.styles'

interface HeaderGroupCellProps {
  colEnd: number
  colStart: number
  columnGroupHeaderRenderer?: (groupId: string) => ReactNode
  groupId: string
  index: number
  columnPinning: ColumnPinning
  stickyControllerRef: RefObject<StickyController>
  isLastGroup?: boolean
}
export const HeaderGroupCell = ({
  colEnd,
  colStart,
  columnGroupHeaderRenderer,
  groupId,
  index,
  columnPinning,
  stickyControllerRef,
  isLastGroup,
}: PropsWithChildren<HeaderGroupCellProps>) => {
  const cellRef = useRef<HTMLDivElement>(null)

  const cellKey = `group-cell-${groupId}`

  useEffect(() => {
    if (stickyControllerRef.current) {
      if (cellRef.current) {
        stickyControllerRef.current.registerHeaderCell(
          cellRef.current,
          cellKey,
          index,
          groupId,
          true,
        )
      } else {
        stickyControllerRef.current.unregister(cellKey)
      }
    }
  }, [groupId, cellRef, cellKey, index, stickyControllerRef])

  return (
    <S.HeaderGroupCellRoot
      ref={cellRef}
      $colStart={colStart}
      $colEnd={colEnd}
      $isSticky={columnPinning !== ColumnPinning.None}
      $withRightBorder
      $isHeaderCell
      {...getLeftRightVars(columnPinning, stickyControllerRef, colStart - 1)}
      className={`${gridClassNames.columnGroupHeaderCell} ${gridClassNames.columnGroupHeaderCell}-${index}`}
      $noRightBorder={isLastGroup}
    >
      <S.ColumnGroupLabel className={gridClassNames.columnGroupLabel}>
        {columnGroupHeaderRenderer ? columnGroupHeaderRenderer(groupId) : groupId}
      </S.ColumnGroupLabel>
    </S.HeaderGroupCellRoot>
  )
}
